import React from 'react'
import { Routes, Route, Outlet } from 'react-router-dom'
import { CartProvider } from './context/CartContext'
import Header from './components/Header'
import Footer from './components/Footer'
import CartDrawer from './components/CartDrawer'
import ScrollToTop from './components/ScrollToTop'
import DiscountPopup from './components/DiscountPopup'
import Home from './pages/Home'
import Shop from './pages/Shop'
import ProductDetails from './pages/ProductDetails'
import BulkOrders from './pages/BulkOrders'
import About from './pages/About'
import Contact from './pages/Contact'
import Checkout from './pages/Checkout'
import OrderConfirmation from './pages/OrderConfirmation'
import AdminLogin from './pages/AdminLogin'
import AdminDashboard from './pages/AdminDashboard'
import NotFound from './pages/NotFound'

// Layout for public site (with Header/Footer)
const PublicLayout = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <CartDrawer />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
)

function App() {
  return (
    <CartProvider>
      <ScrollToTop />
      <DiscountPopup />
      <Routes>
        {/* Public Routes with Header/Footer */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:slug" element={<ProductDetails />} />
          <Route path="/bulk-orders" element={<BulkOrders />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
        </Route>
        
        {/* Admin Routes - Clean, no public Header/Footer */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />}>
          <Route index element={<AdminDashboard />} />
          <Route path="orders" element={<AdminDashboard />} />
          <Route path="quotes" element={<AdminDashboard />} />
          <Route path="contacts" element={<AdminDashboard />} />
          <Route path="inquiries" element={<AdminDashboard />} />
          <Route path="products" element={<AdminDashboard />} />
        </Route>

        {/* 404 Catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </CartProvider>
  )
}

export default App
